import createLocalSeedBackupsPlugin from './local-seed-backups.js'

export const localSeedBackupsPluginDefinition = {
  id: 'localSeedBackupsPlugin',
  type: 'plugin',
  factory: createLocalSeedBackupsPlugin,
  dependencies: [
    'port',
    'localSeedBackups',
    'localSeedBackupsAtom',
    'localSeedBackupMaxAgeAtom',
    'wallet',
    'config',
    'logger',
  ],
  public: true,
}
